import { useEffect, useState } from "react";
import Papa from "papaparse";
import Sugar from "sugar";
import { ungzip } from "node-gzip";

import * as firebase from "firebase/app";
import "firebase/firestore";

const storage = {};

let firebaseConfig = {
  apiKey: "AIzaSyD9IW0jiWw-jGsqCsYi_uwicscRP6UQ3tI",
  authDomain: "inquirer-269515.firebaseapp.com",
  databaseURL: "https://inquirer-269515.firebaseio.com",
  projectId: "inquirer-269515",
  storageBucket: "inquirer-269515.appspot.com",
  messagingSenderId: "444130967593",
  appId: "1:444130967593:web:fcf17c1d6938e094fa5c38"
};

if (firebase.apps.length === 0) firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

// firebase
//   .firestore()
//   .enablePersistence()
//   .catch(function(err) {
//     if (err.code == "failed-precondition") {
//       console.log("Can't cache due to failed precondition");
//     } else if (err.code == "unimplemented") {
//       console.log("Can't cache due to browser support");
//     }
//   });


function useData(limit) {
  const key = "full-data";

  const [data, setData] = useState(storage[key] ? storage[key] : []);

  useEffect(() => {
    if (!storage[key]) {
      (async () => {
        let query = await db.collection("datasets/2020/degrees");

        if (limit) query = query.limit(limit);

        let degrees = query.get();
        storage[key] = degrees.docs.map(x => x.data());
        setData(storage[key]);
      })();
    }
  }, [key]);

  return data;
}

function useQueriedData(searchParams, degreeFilters, order, limit) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let searchKeys = Object.keys(searchParams);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      let query = db.collection("datasets/2020/degrees");

      searchKeys.forEach(
        key => (query = query.where(key, "==", searchParams[key]))
      );

      // console.log( degreeFilters );
      if (degreeFilters.length)
        query = query.where(
          "degreeLevel",
          "in",
          degreeFilters.map(x => x.toString())
        );

      if( limit > 0 )
        query = query.limit(limit)

      query = query.orderBy( order.field, order.direction );

      let degrees = await query.get();
      setIsLoading(false);
      setData(degrees.docs.map(x => x.data()));
    })();
  }, [JSON.stringify(searchParams), degreeFilters]);

  return { data, isLoading };
}

function useScorecardData(unitid, cipCode, degreeLevel) {
  const [data, setData] = useState({
    majors: []
  });

  useEffect(() => {
    (async () => {
      // let query = await db.collection('datasets/2020/degrees').where('unitid', '==', unitid).where('cipCode', '==', cipCode).where('degreeLevel', '==', degreeLevel).get();
      // let scorecard = query.docs[0] ? query.docs[0].data() : {}
      let hash = `${cipCode}.${degreeLevel}`;
      let majors = storage[hash];

      if (!majors) {
        let query = await db
          .collection("datasets/2020/degrees")
          .where("cipCode", "==", cipCode)
          .where("degreeLevel", "==", degreeLevel)
          .get();
        majors = query.docs.map(x => x.data());
        storage[hash] = majors;
      } else {
        console.log("FROM CACHE");
      }

      let scorecard = majors.find(x => x.unitid === unitid);

      setData({
        scorecard,
        majors
      });
    })();
  }, [unitid, cipCode, degreeLevel]);

  return data;
}

function useSearchData() {
  const [data, setData] = useState([]);

  useEffect(() => {
    (async () => {
      let search = storage["search-params"];

      if (!search) {
        let query = await db.collection("datasets/2020/search").get();
        search = query.docs.map(x => x.data());
        storage["search-params"] = search;
      } else {
        console.log("SEARCH FROM CACHE");
      }

      setData(search);
    })();
  }, []);

  return data;
}

// function useCollectionData(collection, degreeFilters, order, limit) {
//   const [data, setData] = useState([]);
//   const [isLoading, setIsLoading] = useState(true);
//
//   useEffect(() => {
//     (async () => {
//       setIsLoading(true);
//
//       let query = db.collection(
//         `datasets/2020/collections/${collection}/degrees`
//       );
//
//       if (degreeFilters.length)
//         query = query.where(
//           "degreeLevel",
//           "in",
//           degreeFilters.map(x => x.toString())
//         );
//
//       if( limit > 0 )
//         query = query.limit(limit)
//
//       query = query.orderBy( order.field, order.direction );
//       let degrees = await query.get();
//
//       setIsLoading(false);
//       setData( degrees.docs.map(x => x.data()) );
//     })();
//   }, [collection, degreeFilters]);
//
//   return { data, isLoading };
// }


function useCollectionData(collection, degreeFilters, order, limit) {
  const [source, setSource] = useState([]);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      let database = source;
      if( source.length == 0 )
      {
        database = require(`./widgets/${ collection }.json`);
        setSource( database );
      }

      setData( database.filter( x => degreeFilters.indexOf( parseInt( x.degreeLevel ) ) >= 0 ) )



      setIsLoading(false);
    })();
  }, [collection, degreeFilters]);

  return { data, isLoading };
}

function useWidgetScorecardData( collection, unitid, cipCode, degreeLevel ) {
  const [isLoading, setIsLoading] = useState(true);

  const [data, setData] = useState({
    majors: []
  });

  const [all, setAll] = useState([]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);

      let database = all;
      if( database.length == 0 )
      {
        database = require(`./widgets/${ collection }-related.json`)
        setAll( database );
      }

      setIsLoading(false);

      console.log( database );

      let majors = database.filter( x => x.cipCode === cipCode && x.degreeLevel === degreeLevel );
      let scorecard = majors.find(x => x.unitid === unitid);

      setData({
        scorecard,
        majors
      });

    })();
  }, [unitid, cipCode, degreeLevel]);

  return data;

}


export {
  useData,
  useScorecardData,
  useSearchData,
  useQueriedData,
  useCollectionData,
  useWidgetScorecardData
};
